module.exports = __webpack_public_path__ + "img/customerLogo8.2ea678d9.png";